import m from "../../es2015/lang/zh_Hant";
window.am4lang_zh_Hant = m;


//////////////////
// WEBPACK FOOTER
// ./lang/zh_Hant.js
// module id = null
// module chunks = 